import React from 'react'

export const Home = () => {
  return (
    <div>
      <section>
  <div className='herosection img-fluid'>
    <div className='herocontent' data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
      <h6 className='menssh'> Mens Shoe</h6>
      <h1 className='heading'>New Air Sneaker flash</h1>
       <p className='para'>Lorem ipsum dolor sit amet consectetur adipisicing <br /> Modi dignissimos hic inventore enim vitae vero.</p>
      <a href="/Product"><button className='homeherobtn'>Go to Collection</button></a>
    </div>
    <div>
    
    </div>
     
  </div>
 </section>

 <section className='sidespace'>
  <div className='picksheading'>
  <h3 className='pickword'>Top Picks</h3>
 <a href="/Product"><button className='picksbtn'>Products</button></a> 

  </div>
 
  <div className='toppicksflex'>
    <div className='shoebox'>
      <img src="./images/shoeone.png" alt=""  className='shoeone img-fluid' data-aos="flip-right"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000" />
      <h4 className='shoename'>Nike Air Force 1 Mid 07</h4>
      <h6 className='shoeprice'>₹ 10,795.00</h6>
    </div>
    <div className='shoebox'>
      <img src="./images/shoetwo.png" alt=""  className='shoeone img-fluid' data-aos="flip-right"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000"/>
      <h4 className='shoename'>LeBron NXXT gen Ep</h4>
      <h6 className='shoeprice'>₹ 14,995.00</h6>
    </div>
    <div className='shoebox'>
      <img src="./images/shoethree.png" alt=""  className='shoeone img-fluid' data-aos="flip-right"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000"/>
      <h4 className='shoename'>Nike Blazer Mid '77 Vintage</h4>
      <h6 className='shoeprice'>₹ 7,795.00</h6>
    </div>
  </div>
 </section>
 <section className='sidespace'>

   <h4 className='latesttxt'>Latest Arrivals</h4>
  <div className='bannerbackground'>
    <h6 className='bannertype'>Unisex shoe</h6>
    <h2 className='bannerheading'>Nike Revolution EasyOn 77</h2>
    <p className='bannerpara'> Modi dignissimos hic inventore enim vitae<br /> vero dolor sit amet consectetur </p>
    <a href="/Product"><button className='bannerbtn' data-aos="fade-left"
     data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="1500">Shop Now</button></a> 
  </div>
  <div className='downbanners' data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
    <img src="./images/bannertwo.png" alt=""  className='bannertwo img-fluid '/>
    <img src="./images/bannerthree.png" alt="" className='bannertwo img-fluid' />
    <img src="./images/bannerone.png" alt="" className='bannertwo img-fluid' />
  </div>
 </section>
 <section className='sidespace'>
  <div className='contentflex'>
     <div className='lastcontent' data-aos="fade-right"
     data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="1500">
      <h6 className='lastcontentone'>Create your design</h6>
      <h1 className='lastcontenttwo'>NIKE REACT PRESTRO <br />BY YOU </h1>
      <p className='lastcontentthree'>Take advantage of brand new proprietary cushioning <br />technology with a fresh pair of Nike React Shoes</p>
      <a href="/Product"><button className='lastcontentbtn'>Create Your's</button></a>
     </div>
     <div data-aos="fade-left"
     data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="1500">
   
    <img src="./images/image61.png" alt="" className='contentimage img-fluid'/>
  </div>
  </div>
 
 </section>
 <section className='footerbox'>
  <div className='sidespace'>
    <div className='rowflex'>
    <div>
      <img src="./images/jordanlogo.png" alt="" className='footerlogo'/>
      <p className='footerpara'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, saepe dolor. Exercitationem commodi eveniet accusantium deserunt ex cumque. ter impedit atque consectetur </p>
      <p className='mailheading'>Receive mail at your mail</p>
      <div className='inputflex'>
      <input type="text" placeholder='Mail id' className='inputbox'/>
      <button className='sendbox'>Send</button>
      </div>
     
     </div>
     <div>
      <h5 className='secondrow'>Products</h5>
      <p className='footersecondrow'>Running shoe</p>
      <p className='footersecond'>Sports shoe</p>
      <p className='footersecond'>Formal shoe</p>
      <p className='footersecond'>Causal shoe</p>
      <p className='footersecond'>Sneakers shoe</p>
     </div>
     <div>
      <h5 className='secondrow'>Support</h5>
      <p className='footersecondrow'>Privacy Policy</p>
      <p className='footersecond'>Terms & Condition</p>
      <p className='footersecond'>Cookies settings</p>
      <p className='footersecond'>Contact us</p>
      <p className='footersecond'>Customer care</p>
     
    
     </div>
     <div>
      <h5 className='secondrow'>Contacts</h5>
     <div className='phoneflex'>
        <p   class='bx bx-phone-call footerphone' ></p>
        <p className='footernumber'> +99 98564 63277</p>
     </div>
     <div className='mailflex'>
        <p   class='bx bx-envelope footerphone' ></p>
        <p className='footernumber'> shoelace@gmail.com</p>
     </div>
     <div className='mailflex'>
        <p   class='bx bx-map footerphone' ></p>
        <p className='footernumber'> 27 B benseroad <br />Newyork USA</p>
     </div>
      </div>
    </div>
    <hr className='footerline'/>
    <div className='downfooterflex'>
      <div className='dfone'>
        <img src="./images/paymentcard.png" alt=""  className='paymentone'/>
        <p className='copyright'>Copyright@Dpdesigner/2023</p>      
      </div>
      <div className='dftwo'>
        <img src="./images/smtwo.png" alt="" className='paymenttwo' />
        <p className='copyright'>All Rights Reserved</p>      
      </div>
    </div>
    
    
  </div>
 </section>
    
    </div>
  )
}

